import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  wrapper: {
    minWidth: 200,
    width: '100%',
  },
}));
